//
export default [
    {
        text: '#',
        value: 'id',
    },
    {
        text: 'nombre',
        value: 'hr_employee_full_name',
    },
    /*{
        text: 'código usuario',
        value: 'auth_code',
        align: 'center',
        component: {
            type: 'chip',
            props: {
                disabled: true,
                label: true,
                small: true,
                textColor: 'black',
            }
        },
    },*/
    {
        text: 'token',
        value: 'g_workstation_user_url_token',
        component: {
            type: 'chip-label',
            props: {
                small: true,
            }
        },
    },
    {
        text: 'tipo',
        value: 'type_name',
        align: 'center',
        component: {
            type: 'chip-label',
            props: {
                small: true,
            }
        },
    },
    {
        text: 'creación',
        value: 'created_at',
        align: 'right',
        format: 'datetime',
    },
]